

export class ApiTemplate {
    name!: string;
    templateList: Array<ApiTemplateRow> = new Array<ApiTemplateRow>();

    constructor(apiTemplate?: any) {
        if (!!apiTemplate) {
            this.name = apiTemplate['name'];
            if (apiTemplate['templateList'] != null){
                this.templateList = apiTemplate['templateList'].map((x: any) => new ApiTemplateRow(x));
            }
        }
    }
}

export class ApiTemplateRow {
    tempId!: string;
    email!: string;
    projNo!: string;
    projName!: string;
    taskNo!: string;
    taskName!: string;
    expType!: string;
    name!: string;
    startDt: Date | undefined;
    endDt: Date | undefined;
    mon: number = 0;
    tue: number = 0;
    wed: number = 0;
    thu: number = 0;
    fri: number = 0;
    sat: number = 0;
    sun: number = 0;

    constructor(apiTemplateRow?: any) {
        if (!!apiTemplateRow) {
            this.tempId = apiTemplateRow['tempId'];
            this.email = apiTemplateRow['email'];
            this.projNo = apiTemplateRow['projNo'];
            this.projName = apiTemplateRow['projName'];
            this.taskNo = apiTemplateRow['taskNo'];
            this.taskName = apiTemplateRow['taskName'];
            this.expType = apiTemplateRow['expType'];
            this.startDt = apiTemplateRow['startDt'];
            this.endDt = apiTemplateRow['endDt'];
            this.mon = apiTemplateRow['mon'];
            this.tue = apiTemplateRow['tue'];
            this.wed = apiTemplateRow['wed'];
            this.thu = apiTemplateRow['thu'];
            this.fri = apiTemplateRow['fri'];
            this.sat = apiTemplateRow['sat'];
            this.sun = apiTemplateRow['sun'];
            this.name = apiTemplateRow['name'];
        }
    }
}

